import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import ReviewsShowcase from './components/ReviewsShowcase';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ACTuneUpPage from './pages/ACTuneUpPage';
import HeatingMaintenancePage from './pages/HeatingMaintenancePage';
import HeatingCoolingServicesPage from './pages/HeatingCoolingServicesPage';
import AirDuctCleaningPage from './pages/AirDuctCleaningPage';
import EmergencyServicesPage from './pages/EmergencyServicesPage';
import ThermostatInstallationPage from './pages/ThermostatInstallationPage';
import FAQPage from './pages/FAQPage';
import MaintenancePlansPage from './pages/MaintenancePlansPage';
import RestaurantEquipmentRepairPage from './pages/RestaurantEquipmentRepairPage';
import BlogPage from './pages/BlogPage';
import AirConditioningServiceRosevilleCA from './pages/blog/AirConditioningServiceRosevilleCA';
import AirConditionerServiceRoseville from './pages/blog/AirConditionerServiceRoseville';
import ACRepairRoseville from './pages/blog/ACRepairRoseville';
import FurnaceRepairRoseville from './pages/blog/FurnaceRepairRoseville';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');

  // Handle scroll to update active section
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'about', 'gallery', 'testimonials', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Navigation handler
  const handleNavigate = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="min-h-screen">
      <Header activeSection={activeSection} onNavigate={handleNavigate} />
      <main>
        <HeroSection onNavigate={handleNavigate} />
        <ServicesSection onNavigate={handleNavigate} />
        <AboutSection />
        <GallerySection />
        <TestimonialsSection />
        <ReviewsShowcase />
        <ContactSection />
      </main>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/ac-tune-up" element={<ACTuneUpPage />} />
        <Route path="/services/heating-maintenance" element={<HeatingMaintenancePage />} />
        <Route path="/services/all" element={<HeatingCoolingServicesPage />} />
        <Route path="/services/air-duct-cleaning" element={<AirDuctCleaningPage />} />
        <Route path="/services/emergency" element={<EmergencyServicesPage />} />
        <Route path="/services/thermostat-installation" element={<ThermostatInstallationPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/maintenance-plans" element={<MaintenancePlansPage />} />
        <Route path="/services/restaurant-equipment" element={<RestaurantEquipmentRepairPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/air-conditioning-service-roseville-ca" element={<AirConditioningServiceRosevilleCA />} />
        <Route path="/blog/air-conditioner-service-roseville" element={<AirConditionerServiceRoseville />} />
        <Route path="/blog/ac-repair-roseville-ca" element={<ACRepairRoseville />} />
        <Route path="/blog/furnace-repair-roseville-ca" element={<FurnaceRepairRoseville />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
